<template>

    <div class="row">
        <div class="col-sm-4 col-sm-offset-4">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Contract bekijken voor gebruiker: {{ getHrUser.fullname }}</h2>
                </div>
                <div class="box-body">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-sm-6">
                                <label>Gebruikersgroep</label>
                                <p class="form-control-static">{{ contract.usergroup }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-sm-6">
                                <label>Type:</label>
                                <p class="form-control-static">{{ contract.type }}</p>
                            </div>
                            <div class="col-sm-6">
                                <label>Functiegroep:</label>
                                <p class="form-control-static">{{ contract.functiongroup }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Looptijd:</label>
                        <p class="form-control-static">{{ contract.duration === "set" ? "Bepaalde tijd" : "Onbepaalde tijd" }}</p>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-sm-6">
                                <label class="control-label">Start datum:</label>
                                <p class="form-control-static">{{ contract.start }}</p>
                            </div>
                            <div class="col-sm-6" v-if="contract.end !== null">
                                <label class="control-label">Eind datum:</label>
                                <p class="form-control-static">{{ contract.end }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-sm-6">
                                <label>Bruto salaris:</label>
                                <p class="form-control-static">{{ contract.salary * 100 | toCurrency }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group table-responsive">
                        <table class="table">
                            <tbody>
                                <tr>
                                    <th>Inhoudingen</th>
                                    <th>Vakantietoeslag</th>
                                    <th>Sociale lasten</th>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="form-control-static">{{ contract.deduction }}%</p>
                                    </td>
                                    <td>
                                        <p class="form-control-static">{{ contract.vacationbonus }}%</p>
                                    </td>
                                    <td>
                                        <p class="form-control-static">{{ contract.socialsecurity }}%</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-sm-6">
                                <label>Contract uren (week):</label>
                                <p class="form-control-static">{{ contract.weeklyhours }}</p>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Vakantie uren per kalenderjaar:</label>
                                    <p class="form-control-static">{{ contract.vacationhours }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group table-responsive">
                        <table class="table">
                            <tbody>
                                <tr>
                                    <th class="text-center">Ma</th>
                                    <th class="text-center">Di</th>
                                    <th class="text-center">Wo</th>
                                    <th class="text-center">Do</th>
                                    <th class="text-center">Vr</th>
                                    <th class="text-center">Za</th>
                                    <th class="text-center">Zo</th>
                                </tr>
                                <tr class="text-center">
                                    <td v-for="a in ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su']">
                                        {{ contract.daily[a] }}
                                        <span v-if="contract['even-odd-weeks'] && contract.daily[a] !== contract['daily-odd'][a]">
                                             / {{ contract['daily-odd'][a] }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { mapGetters } from "vuex";

export default {

    computed:{
        ...mapGetters([
            'getHrUser',
            'getHrUserContracts',
        ]),

        contract() {
            if (!this.$route.params.contract_uuid) {
                return null;
            }

            let contract = this.getHrUserContracts.filter(contract => contract.uuid === this.$route.params.contract_uuid);

            return contract.length === 1 ?
                contract[0] :
                null;
        },
    },

    metaInfo: {
        title:'Contract bekijken',
    },

    name:'HrUsersContractsShow',

}

</script>
